import React, { useState, useEffect, useRef } from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import { Icon } from "@iconify/react";
import { Button, Card, Col, Form, Row } from "react-bootstrap";
import Breadcrumb from "../components/Breadcrumb";
import $, { data } from 'jquery';
import 'datatables.net-dt/js/dataTables.dataTables.js';
import 'datatables.net-responsive-dt/js/responsive.dataTables.js';
import 'datatables.net-responsive-dt/css/responsive.dataTables.css';
import { API_URL } from "..";
import { Link } from "react-router-dom";

function getCurrentMonthRange() {
    const now = new Date();
    const startDate = new Date(now.getFullYear(), now.getMonth(), 1);
    
    const formatDate = (date) => {
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, "0");
        const day = String(date.getDate()).padStart(2, "0");
        return `${year}-${month}-${day}`;
    };
    return {
        start_date: formatDate(startDate),
        end_date: formatDate(now)
    };
}

export default function ExpensePage() {
    const { start_date, end_date } = getCurrentMonthRange();
    const [currentUser, setCurrentUser] = useState();
    const [dataExpense, setDataExpense] = useState([]);
    const [filterValues, setFilterValues] = useState({
        start_date: start_date,
        end_date: end_date,
    });
    const tableRef = useRef(null);

    const initializeDataTable = (data) => {
        if ($.fn.DataTable.isDataTable('#expenseTable')) {
            $('#expenseTable').DataTable().destroy();
            $('#expenseTable tbody').empty();
        }

        $('#expenseTable').DataTable({
            responsive: true,
            data: data,
            columns: [
                { data: 'reason', title: 'Reason' },
                { 
                    data: 'amount', 
                    title: 'Amount', 
                    render: (data) => `$${parseFloat(data).toFixed(2)}` 
                },
                { data: 'date', title: 'Date' }
            ],
            destroy: true,
        });
    };

    const getExpenseData = async () => {
        const user = JSON.parse(localStorage.getItem('user'));
        const body = JSON.stringify({
            affiliate_id: user.id,
            start_date: filterValues.start_date,
            end_date: filterValues.end_date
        });
        
        const apiCall = await fetch(API_URL + '/api/reports/income-expense-summary', {
            method: 'POST',
            body: body,
            headers: {
                'Content-Type': 'application/json',
                'Accept': '*/*'
            }
        });
        
        const response = await apiCall.json();
        if (apiCall.status === 200) {
            const expenseLogs = response.logs.filter((e) => e.type === "Expense");
            setDataExpense(expenseLogs.reverse());
            setTimeout(() => {
                initializeDataTable(expenseLogs.reverse());
            }, 100);
        }
    };

    useEffect(() => {
        const getCurrentUser = () => {
            const user = localStorage.getItem("user");
            const json = JSON.parse(user);
            setCurrentUser(json);
        };
        getCurrentUser();
        getExpenseData();
        
        return () => {
            if ($.fn.DataTable.isDataTable('#expenseTable')) {
                $('#expenseTable').DataTable().destroy();
                $('#expenseTable tbody').empty();
            }
        };
    }, []);

    const handleFilter = () => {
        
        if ($.fn.DataTable.isDataTable('#expenseTable')) {
            $('#expenseTable').DataTable().destroy();
            $('#expenseTable tbody').empty();
        }
        getExpenseData();
    };

    return (
        <MasterLayout>
            <Breadcrumb title="Expense Reports" />
            <div className="row mb-3">
                <div className="col-md-6">
                    <div className="row">
                        <div className="col-md-4">
                            <Form.Label>Start Date</Form.Label>
                            <Form.Control 
                                value={filterValues.start_date} 
                                onChange={(e) => setFilterValues((prev) => ({ ...prev, start_date: e.target.value }))} 
                                type="date" 
                            />
                        </div>
                        <div className="col-md-4">
                            <Form.Label>End Date</Form.Label>
                            <Form.Control 
                                value={filterValues.end_date} 
                                onChange={(e) => setFilterValues((prev) => ({ ...prev, end_date: e.target.value }))} 
                                type="date" 
                            />
                        </div>
                        <div className="col-md-4 d-flex" style={{ marginTop: 30, alignItems: 'center' }}>
                            <Button onClick={handleFilter}>Filter</Button>
                        </div>
                    </div>
                </div>
                <div className="col-md-6 text-end">
                    <Link to="/reports">
                        <Button variant="info">Back to Reports</Button>
                    </Link>
                </div>
            </div>

            <div className="row mt-3">
                <div className="col-md-12">
                    <Card>
                        <Card.Header>
                            <p>Expense Logs</p>
                        </Card.Header>
                        <Card.Body>
                          
                          {
                            dataExpense.length === 0 ? 
                            null:
                            <table 
                            id="expenseTable" 
                            ref={tableRef}
                            className="table table-responsive table-striped"
                        >
                            <thead>
                                <tr>
                                    <th>Reason</th>
                                    <th>Amount</th>
                                    <th>Date</th>
                                </tr>
                            </thead>
                            <tbody>
                                {dataExpense.length === 0 && (
                                    <tr>
                                        <td colSpan="3" className="text-center">Nothing to show...</td>
                                    </tr>
                                )}
                            </tbody>
                        </table>
                          }
                        </Card.Body>
                    </Card>
                </div>
            </div>
        </MasterLayout>
    );
}